import React from "react";
import "./tabsSet.scss";
import TabButton from "componets/atoms/tabButton/tabButton";

//Estructura de tabs Data:
/*
const tabsData = {
        groupName: "comunitySelection",
        tabs: [
            {value: 0, text: "Estudiantes"},
            {value: 1, text: "Docentes"},
            {value: 2, text: "Egresados"},
            {value: 3, text: "Administrativos"}
        ]
    }
 */
const TabsSet = ({ textSize, setSelected, tabsData }) => {
  return (
    <>
      <div className="community-tabs__container">
        {tabsData.tabs.map((tab, index) => (
          <TabButton
            key={index}
            handleChange={(e) => setSelected(e.target.value)}
            textSize={textSize}
            groupName={tabsData.groupName}
            isDefault={index == 0}
            value={tab.value}
            text={tab.text}
          />
        ))}
      </div>
    </>
  );
};

export default TabsSet;
